import { Observable, of } from 'rxjs';
import { ICloudRelayServer } from '../../../../java/interfaces/';

export function cloudRelayDiscoveryMode(serverObject: ICloudRelayServer): Observable<string> {
  const _mode = serverObject.discoveryMode;
  switch (_mode) {
    case 0:
      return of('Out of Service');
      break;
    case 1:
      return of('Production');
      break;
    case 2:
      return of('Test');
      break;
    default:
      return of('Unknown');
      break;
  }
}
